export default __webpack_public_path__ + "static/media/scroll-down.027c6022.gif";